module.exports = __webpack_public_path__ + "img/turkmenistan.d7a4bb2d.svg";